import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-brand-orange/10 text-brand-orange">
        <i className="fa-solid fa-lock text-4xl" />
      </div>
      <h1 className="text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">403 - Adgang nægtet</h1>
      <p className="mt-4 max-w-md text-base text-slate-500">
        Du har ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte vores support.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="rounded-md bg-brand-accent px-6 py-3 text-sm font-semibold uppercase tracking-wider text-white transition-all hover:bg-brand-accent/80"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/kontakt"
          className="rounded-md border border-slate-200 bg-white px-6 py-3 text-sm font-semibold uppercase tracking-wider text-slate-800 transition-all hover:bg-slate-50"
        >
          Kontakt os
        </Link>
      </div>
    </div>
  );
}
